$mol_view_tree2_to_js_test_ex_bidi_legacy_value_foo $mol_object
	a?v <=> b?v 1
